
<template>
  <div style="margin-left:50px;">

    <el-form style="display: flex;flex-wrap: wrap;">

        <!-- <el-form-item label="教师名称:" style="display: flex;width: 33%;">
            <el-select
                placeholder="请选择教师"
                v-model="student"
                style="width: 100%"
                clearable
                filterable>
                <el-option
                v-for="item in getStudentsArr"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
        </el-form-item> -->

        <el-form-item label="创建人:" style="display: flex;width: 33%; margin-left: -14px;" >
            <el-select
                placeholder="请选择创建人"
                v-model="student_s"
                style="width: 100%"
                clearable
                filterable>
                <el-option
                v-for="item in getStudentsArr_s"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="方案名称:" style="display: flex;width: 33%;" >
            <!-- <el-select
                placeholder="请选择方案名称"
                v-model="coursecancellationStatusInput"
                style="width: 100%"
                clearable
                filterable >
                <el-option
                v-for="item in coursecancellationStatus"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select> -->

            <el-input v-model="coursecancellationStatusInput" placeholder="请输入方案名称"></el-input>

        </el-form-item>


        <el-form-item label="日期:" style="display: flex;width: 60%;">
            <el-date-picker
            style="width: 100%;"
            v-model="dateTimeList"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable>
            </el-date-picker>
        </el-form-item>


        <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
             <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
             <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
             <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
             <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus" @click="addBtns">添加培训</el-button>
        </div>

    </el-form>


    <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
        <el-table-column prop="createUserName" label="创建人"></el-table-column>
        <el-table-column prop="trainName" label="方案名称"></el-table-column>
        <el-table-column prop="createTime" label="日期">
          <template slot-scope="scope">
             <span>{{scope.row.createTime.substring(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-around;">
                <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button>
                <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
              </div>
            </template>
        </el-table-column>
      </el-table>



    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
    </el-pagination>



    <el-dialog :title="ShowDlongTitle" :visible.sync="ShowDlong" :before-close="commitCler">

        <el-form ref="form" :model="form" label-width="80px">

            <el-form-item label="教师姓名:">
                <el-select
                    placeholder="请选择教师"
                    v-model="form.student"
                    style="width: 100%"
                    clearable
                    :disabled="ShowDlongDisabled"
                    filterable>
                    <el-option
                    v-for="item in getStudentsArr"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="审批人:">
              <el-select
                placeholder="请选审批人"
                v-model="form.student_s"
                style="width: 100%"
                clearable
                :disabled="ShowDlongDisabled"
                filterable>
                <el-option
                v-for="item in getStudentsArr_s"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
            </el-form-item>

           <el-form-item label="培训方式:">
            <el-select
                placeholder="请选择培训方式"
                v-model="form.coursecancellationStatusInput"
                style="width: 100%"
                clearable
                :disabled="ShowDlongDisabled"
                filterable >
                <el-option
                v-for="item in coursecancellationStatus"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
           </el-form-item>

           <el-form-item label="日期范围:">
                <el-date-picker
                :disabled="ShowDlongDisabled"
                style="width: 100%;"
                v-model="form.dateTimeList"
                type="date"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable>
                </el-date-picker>
            </el-form-item>


        </el-form>


        <div slot="footer" class="dialog-footer">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="commitCler">取消</el-button>
          <el-button v-if="!ShowDlongDisabled" style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="commitAdd">提交</el-button>
        </div>

    </el-dialog>



    <el-dialog :title="titleAddShowDlong" width="80%" style="padding: 0px 10px;" :visible.sync="AddShowDlong" :before-close="AddcommitCler"  :close-on-click-modal="false">

        <el-form ref="form" :model="form" label-width="100px">

            <el-form-item label="方案名称:" :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' ">
                <el-input placeholder="请输入方案名称" v-model="Addform.TrainName" style="width: 100%" clearable>
                </el-input>
            </el-form-item>

            <!-- <el-form-item label="任务创建人:">
              <el-select
                placeholder="请选任务创建人"
                v-model="Addform.CreatorName"
                style="width: 100%"
                clearable
                filterable>
                <el-option
                    v-for="item in getStudentsArr_s"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname">
                </el-option>
            </el-select>
            </el-form-item> -->

           <el-form-item label="参加培训人:" :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' ">
            <el-select
                placeholder="请选择参加培训人"
                v-model="Addform.TrainerName"
                @remove-tag="handleRemoveTag"
                ref="select"
                style="width: 100%"
                clearable
                multiple
                filterable>
                 <el-option
                     v-for="item in coursecancellationStatus"
                     :key="item.id"
                     :value="item.id"
                     :label="item.realname" >
                 </el-option>
            </el-select>
           </el-form-item>

           <el-form-item label="培训内容:" style="margin-bottom: 30px;">
                <div style="width: 100%;overflow-x: auto;height: 90px; padding-top: 17px;">
                    <el-steps :active="activeStep" simple style="">
                        <el-step v-for="(itme,index) in newObj.dateList" :key="index" :title="itme" @click.native="handleStep(itme,index)"></el-step>
                    </el-steps>
                    <div  :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' " style="position: absolute;top: 24px;left:2px;" ><i  @click="handleAdd" class="el-icon-circle-plus-outline" style="font-size: 28px;"></i></div>
                    <div :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' "  v-if="newObj.dateList.length > 1" style="position: absolute;top: 54px;left:2px;"><i  @click="handleSubtraction" class="el-icon-remove-outline" style="font-size: 28px;"></i></div>
                </div>


                <div style="width: 100%;height: 350px;flex-wrap: wrap;display: flex;overflow: auto;padding: 20px 0px;">
                    <el-card style="height: 100%;width: 400px;border-radius: 20px;margin-left: 10px;margin-top: 10px;margin-right: 12px;overflow: auto;"
                              v-for="(itme,index) in newObj.dataCardList[activeStep]" :key="index">
<!--
                        <div v-if="index === 0" style="display: flex;" >
                            <div style="width: 93%;padding-left: 30px;font-size: 18px;font-weight: 900;">任务{{newObj.dataCardList[activeStep].length}}</div>
                            <i @click="handleAddCard('Add')" class="el-icon-circle-plus-outline" style="font-size: 28px;"></i>
                        </div>
                        <div v-else style="display: flex;">
                            <div style="width: 93%;padding-left: 30px;font-size: 18px;font-weight: 900;">任务{{newObj.dataCardList[activeStep].length}}</div>
                            <i @click="handleAddCard('reduce',index)" class="el-icon-remove-outline" style="font-size: 28px;"></i>
                        </div>   -->


                        <div style="display: flex;margin-bottom: 20px;"  :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' ">
                            <i @click="handleAddCard('Add')" class="el-icon-circle-plus-outline" style="font-size: 28px;"></i>
                            <div style="width: 93%;padding-left: 14px;font-size: 18px;font-weight: 900;line-height: 22px;">
                                任务{{
                                    index == 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' :
                                    index == 5 ? '六' : index === 6 ? '七' : index == 7 ? '八' : index === 8 ? '九' : index === 9 ? '十' :
                                    index == 10 ? '十一' : index == 11 ? '十二' : index == 12 ? '十三' : index == 13 ? '十四' : index == 14 ? '十五' :
                                    index == 15 ? '十六' : index == 16 ? '十七' : index === 17 ? '十八' : index === 18 ? '十九' : index === 20 ? '二十' :
                                    index == 21 ? '二十一' : index === 22 ? '二十二' : index == 23 ? '二十四' : index == 24 ? '二十五' : index === 25 ? '二十六' :
                                    index === 27 ? '二十八' : index === 28 ? '二十九' : index == 29 ? '三十' : '三十一'
                                }}
                            </div>
                            <i v-if="index !== 0" @click="handleAddCard('reduce',index,itme)" class="el-icon-remove-outline" style="font-size: 28px;"></i>
                        </div>


                        <div style="display: flex;width: 100%;font-size:10px;margin-bottom: 10px;"  :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' ">
                            <div style="width: 65px;">任务名称：</div>
                            <div style="width: 80%;">
                                <el-input style="width: 86%;margin-left: -28px;font-size: 12px;" v-model="itme.taskName" placeholder="请输入任务名称"></el-input>
                            </div>
                        </div>
                        <div style="display: flex;width: 100%;font-size:10px;margin-bottom: 10px;"  :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' ">
                            <div style="width: 65px;">任务内容：</div>
                            <div style="width: 80%;">
                                <el-input style="width: 86%;margin-left: -28px;font-size: 12px;"  v-model="itme.taskContent" type="textarea"  maxlength="200"  show-word-limit placeholder="请输入任务描述"></el-input>
                            </div>
                        </div>
                        <div style="display: flex;width: 100%;font-size:10px;margin-bottom: 10px;" >
                            <div style="width: 65px;">相关资料：</div>
                            <el-button   :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' " type="text" style="color:#00aaff;margin-left: 10px;font-size: 12px;padding-top: 4px;" @click="handdleClickImg(itme,index)">上传</el-button>
                            <div style="width: 80%; height: 50px;  overflow-y: auto;">
                                <div v-for="(itmes,index_s) in itme.taskDataS" :key="index_s">
                                    <span style="color:#1a88e9" @click="handleVideo(itmes.url)">{{itmes.name}}</span>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;width: 100%;font-size:10px;margin-bottom: 10px;"  :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' ">
                            <div style="width: 100px;">是否可下载资料：</div>
                            <div style="width: 80%;text-align: start;padding-left: 10px;">
                                <el-radio v-model="itme.isDown" :label="1">否</el-radio>
                                <el-radio v-model="itme.isDown" :label="2">是</el-radio>
                            </div>
                        </div>
                        <div style="display: flex;width: 100%;font-size:10px;margin-bottom: 10px;"  :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' ">
                            <div style="width: 65px;">是否打分：</div>
                            <div style="width: 80%;text-align: start;padding-left: 10px;">
                                <el-radio v-model="itme.isMark" :label="1">否</el-radio>
                                <el-radio v-model="itme.isMark" :label="2">是</el-radio>
                            </div>
                        </div>
                        <div style="display: flex;width: 100%;font-size:10px;margin-bottom: 10px;"  :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' ">
                            <div style="width: 65px;">是否问卷：</div>
                            <div style="width: 80%;text-align: start;padding-left: 10px;">
                                <el-radio v-model="itme.isAnswer" :label="1">否</el-radio>
                                <el-radio v-model="itme.isAnswer" :label="2">是</el-radio>
                            </div>
                        </div>
                        <div style="display: flex;width: 100%;font-size:10px;margin-bottom: 10px;" v-if="itme.isAnswer === 2"  :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' ">
                            <div style="width: 65px;">答卷入口：</div>
                            <div style="width: 80%;">
                                <el-select style="width: 86%;margin-left: -25px;" v-model="itme.taskAnswer"   placeholder="请选择答卷入口">
                                    <el-option  v-for="item in reviewerOptions_s" :key="item.questionnaireId" :label="item.questionnaireTitle"  :value="item.questionnaireId"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <!-- <div style="display: flex;width: 100%;font-size:10px;margin-bottom: 10px;">
                            <div style="width: 65px;">创建时间：</div>
                            <div style="width: 80%;">
                                <el-date-picker
                                    style="width: 86%;margin-left: -28px;font-size: 12px;"
                                    v-model="itme.creationTime"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    placeholder="选择创建时间">
                                </el-date-picker>
                            </div>
                        </div> -->
                        <div style="display: flex;width: 100%;font-size:10px;"  :class=" titleAddShowDlong === '培训任务详情' ? 'no_click' : '' ">
                            <div style="width: 65px;">审批人：</div>
                            <div style="width: 80%;">
                                <el-select style="width: 86%;margin-left: -25px;" v-model="itme.auditId"   placeholder="请选择审批人">
                                    <el-option  v-for="item in reviewerOptions" :key="item.id" :label="item.realname"  :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-card>
                </div>

           </el-form-item>



           <!-- <el-form-item label="资料上传:">
                <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :on-remove="handleRemove"
                    :beforeUpload="beforeUpload"
                    :http-request="handleUpload"
                    :on-error="handleError"
                    :auto-upload="true"
                    show-file-list
                    :file-list="fileDataList"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
           </el-form-item>

           <el-form-item label="审批人:">
                <el-select
                    placeholder="请选择审批人"
                    v-model="Addform.ApprovedName"
                    style="width: 100%"
                    clearable
                    filterable >
                    <el-option
                        v-for="item in coursecancellationStatus"
                        :key="item.id"
                        :value="item.id"
                        :label="item.realname" >
                    </el-option>
                </el-select>
           </el-form-item> -->


        </el-form>


        <div slot="footer" class="dialog-footer">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="AddcommitCler">取消</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="AddcommitSub" v-if="titleAddShowDlong !== '培训任务详情'">保存</el-button>
          <!-- <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddcommitAdd">提交</el-button> -->
        </div>

    </el-dialog>


    <el-dialog title="上传资料" width="50%" style="padding: 50px 50px;" :visible.sync="datahowDlong" :before-close="dataCommitCler" :close-on-click-modal="false">
        <el-upload class="upload-demo" style="height: 350px;"
            drag
            action="#"
            :on-remove="handleRemove_s"
            :beforeUpload="beforeUpload_s"
            :http-request="handleUpload_s"
            :on-error="handleError_s"
            :auto-upload="true"
            show-file-list
            :file-list="fileDataList_s"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <div slot="footer" class="dialog-footer">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="dataCommitCler">取消</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="dataCommitSub">保存</el-button>
        </div>
    </el-dialog>



    <el-dialog title="提示" width="50%" style="padding: 50px 50px;" :visible.sync="datahowDlong_1" :before-close="datahowDlong_1Sub">

        <div style="text-align: center;">删除该老师任务同步删除？</div>

        <div slot="footer" class="dialog-footer">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="datahowDlong_1Cler">是</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="datahowDlong_1Sub">否</el-button>
        </div>

    </el-dialog>



    <el-dialog title="修改提示" width="50%" style="padding: 50px 50px;" :visible.sync="datahowDlong_2" :before-close="datahowDlong_2Sub">

        <div style="text-align: start;display: flex;">
            <div>对所有参训人进行修改任务</div>
            <div style=" margin-left: 40px;">
                <el-radio-group v-model="datahowDlong_2Radio">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="2">否</el-radio>
                </el-radio-group>
            </div>
        </div>
        <div style="text-align: start; margin-top: 40px;">是：点击是后对所有人进行修改操作</div>
        <div style="text-align: start;">否：点击否后，已完成得教师不进行修改操作</div>

        <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="datahowDlong_2Cler">是</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="datahowDlong_2Sub">否</el-button>
        </div>

    </el-dialog>



    <el-dialog title="提示" width="50%" style="padding: 50px 50px;" :visible.sync="datahowDlong_3" :before-close="datahowDlong_3Cler">

         <div style="text-align: start;display: flex;">
             <div>对所有参训人进行任务修改</div>
             <div style=" margin-left: 40px;">
                 <el-radio v-model="datahowDlong_3Radio" label="1">是</el-radio>
                 <el-radio v-model="datahowDlong_3Radio" label="2">否</el-radio>
             </div>
         </div>
         <div style="text-align: start; margin-top: 40px;">是：点击是后对所有人进行修改操作</div>
         <div style="text-align: start;">否：点击否后，已完成得教师不进行删除操作</div>

         <div slot="footer" class="dialog-footer">
             <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="datahowDlong_3Sub">是</el-button>
             <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="datahowDlong_3Cler">否</el-button>
         </div>

     </el-dialog>

      <el-dialog title="视频" width="60%" style="padding: 50px 50px;" :visible.sync="handleVideoShow" :before-close="handleVideoShowCler">
         <video :src="videoSrc" controls="controls" width="100%" height="500"></video>
     </el-dialog>


</div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import Vue from 'vue';
import { ref, reactive, onMounted, defineComponent, toRefs, nextTick, onUpdated, watchEffect } from '@vue/composition-api'
var $Vue = Vue.prototype
import {  getStudentsType } from "@/api/fiveClassApi"
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import loadingUtils from "../utils/loading";
import { isReturn } from "../utils/retnue";
import { getRandomLetterA, getRandomLetterB, getRandomLetterC, getRandomLetterD, getRandomLetterE, getRandomLetterF, getRandomLetterG, getRandomLetterH } from "../utils/max";
import { getTeachers} from "@/api/fiveClassApi"
export default defineComponent({

    setup(props, { attrs, slots, emit, expose, refs }){
        let InputRadio = ref('1')
        let newObj = reactive({dateList:['第一天'],dataCardList:[[{taskDataS:[]}]]})
        let activeStep = ref(0)
        let getStudentsArr = ref([])
        let getStudentsArr_s = ref([])
        let coursecancellationStatus = ref([])
        let student = ref('')
        let student_s = ref('')
        let coursecancellationStatusInput = ref('')
        let dateTimeList = ref([])
        let dataList = ref([])
        let requestParameters = reactive({pageSize:10,total:0,pageNum:0})
        let ShowDlong = ref(false)
        let ShowDlongDisabled = ref(false)
        let ShowDlongTitle = ref('编辑')
        let form = reactive({ student:'', student_s: '', coursecancellationStatusInput:'', dateTimeList: '' })
        let AddShowDlong = ref(false)
        let Addform = reactive({ TrainName:'', CreatorName:'', TrainerName: [], DataUpload: '', ApprovedName: '' })
        let planArr = ref([])
        let fileDataList = ref([])
        let fileDataList_s = ref([])
        // let dataCardList = ref([{}])
        let datahowDlong = ref(false)
        let mapList = ref([[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]])
        let imgIndex = ref(0)
        let reviewerOptions = ref([])
        let reviewerOptions_s = ref([])
        let titleAddShowDlong = ref('添加培训任务')
        let datahowDlong_1 = ref(false)
        let datahowDlong_2 = ref(false)
        let datahowDlong_2Radio = ref('')
        let datahowDlong_3 = ref(false)
        let datahowDlong_3Radio = ref('')
        let select = ref('')
        let newID = ref('')
        let newindex = ref(0)
        let itmeRes = reactive({})
        let edibleTrainId = ref('')
        let tranTeacherIdList = ref([])

        let videoSrc = ref('')
        let handleVideoShow = ref(false)


        onMounted(()=>{
            handleAllApi()

        })

        watchEffect(() => {
            console.log(`Count is now 让子弹飞一会`);
        })



        const handdleClickImg = (itme,index) =>{
            imgIndex.value = index
            datahowDlong.value = true
        }

        const dataCommitCler = () => {
            datahowDlong.value = false
            fileDataList_s.value = []
        }

        const dataCommitSub = () =>{
            datahowDlong.value = false

            newObj.dataCardList[activeStep.value][imgIndex.value].taskDataS = [...newObj.dataCardList[activeStep.value][imgIndex.value].taskDataS,...fileDataList_s.value]

            fileDataList_s.value = []
        }

        const handleStep = (itme,index) => {
            activeStep.value = index
        }


        const handleAdd = () => {

            if(Addform.TrainName){
                let leng = newObj.dateList.length
                let casechisee = numberToChinese(leng + 1)
                let StrigChisee = `第${casechisee}天`
                newObj.dateList.push(StrigChisee)
                newObj.dataCardList.push([{}])
            }else{
                handleMessage("请输入方案名称!", 'warning')
            }
        }

        const handleSubtraction = () =>{
            newObj.dateList.pop()
            newObj.dataCardList.pop()
        }

        const  numberToChinese = (num) => {

             let units = ['', '十', '百', '千', '万', '十万', '百万', '千万', '亿']
             let digits = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']

             if (num < 10) {
                 return digits[num];
             }
             if (num < 20) {
                   return '十' + digits[num - 10];
             }

             let unitIndex = String(num).length - 1;
             let unit = units[unitIndex]

             return digits[Math.floor(num / Math.pow(10, unitIndex))] + unit + numberToChinese(num % Math.pow(10, unitIndex))

        }


        const handleAddCard = (type,index,itme) =>{

            if(type === 'Add'){
                if(Addform.TrainName){
                    newObj.dataCardList[activeStep.value].push({taskDataS:[], taskNumber:  getRandomLetterA() + getRandomLetterB() + getRandomLetterC() + getRandomLetterD() + getRandomLetterE() + getRandomLetterF() + getRandomLetterG() +  getRandomLetterH()})

                    console.log( newObj.dataCardList,'1111111111111')
                    console.log( newObj.dataCardList[activeStep.value], '222222222222222222222')

                    // newObj.dataCardList.push([{}])

                }else{
                    handleMessage("请输入方案名称!", 'warning')
                }
            }

            if(type === 'reduce'){

                if(itme.auditId){
                    console.log(itme, 'itme')
                    newindex.value = index
                    datahowDlong_3.value = true
                    itmeRes = itme

                }else{
                    if(titleAddShowDlong.value === '编辑培训任务'){
                        if(index !== 0){

                            console.log(activeStep.value, '第几天')
                            console.log(itme, 'taskNumber')

                            let result = deleteByIndex(newObj.dataCardList[activeStep.value], index)
                            newObj.dataCardList[activeStep.value] = result

                            console.log(newObj.dataCardList, 'newObj.dataCardList')


                        }
                    }else{
                        if(index !== 0){
                            let result = deleteByIndex(newObj.dataCardList[activeStep.value], index)
                            newObj.dataCardList[activeStep.value] = result
                        }
                    }
                }
            }
        }

        const deleteByIndex = (arr, index) =>{
              arr.splice(index, 1)
              return arr
        }


        const handleAllApi = () =>{

            axios.get(`${apiBaseUrl}/questionnaire/queryTitle`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                //   console.log(res)
                  reviewerOptions_s.value  = res.data.data
              }).catch(error => {
                  console.error(error)
            })



            axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                //   console.log(res)
                  getStudentsArr.value = res.data.data
                  getStudentsArr_s.value = res.data.data
                //   coursecancellationStatus.value  = res.data.data
                  reviewerOptions.value  = res.data.data
              }).catch(error => {
                  console.error(error)
            })


            // getTeachers().then(res => {
            //     coursecancellationStatus.value = res.data
            // })



            axios.get(`${apiBaseUrl}/schedule/teacherAllTrainList`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
                  coursecancellationStatus.value  = res.data.data
             })


            axios.post(`${apiBaseUrl}/train/findTrainPage`, requestParameters,{
                  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  dataList.value = res.data.data.records
                  requestParameters.pageNum = res.data.data.current
                  requestParameters.pageSize = res.data.data.size
                  requestParameters.total = res.data.data.total

              }).catch(error => {
                  console.error(error)
            })

            axios.post(`${apiBaseUrl}/contract/getList`, requestParameters,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                isReturn(res.code)
                planArr.value = res.data.data.records
            }).catch(error => {
                console.error(error)
            })
            getTeachers().then(res => {
                // reviewerOptions.value = res.data
            })
        }

        const handleMessage = (message,type) =>{
             $Vue.$message({ message, type, duration: 500 });
        }


        const exportBtns = () =>{
            let data = {
                createUserId: student_s.value,
                trainName: coursecancellationStatusInput.value,
                createDateStart: `${dateTimeList.value[0] ? dateTimeList.value[0] + ' 00:00:00' : '' }`,
                createDateEnd:  `${dateTimeList.value[1] ? dateTimeList.value[1] + ' 00:00:00' : '' }`,
            }
            axios.post(`${apiBaseUrl}/train/exportTrain`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "添加方案.xlsx";
                    downloadLink.click();
                    handleMessage('导出成功', 'success')
                }
                else{
                    handleMessage('导出失败', 'error')
                }
            })
        }
        const searchBtns = () =>{
            let data = {
                pageNum: requestParameters.pageNum,
                pageSize: requestParameters.pageSize,
                createUserId: student_s.value,
                trainName: coursecancellationStatusInput.value,
                createDateStart: `${dateTimeList.value[0] ? dateTimeList.value[0] + ' 00:00:00' : '' }`,
                createDateEnd:  `${dateTimeList.value[1] ? dateTimeList.value[1] + ' 00:00:00' : '' }`,
            }
            axios.post(`${apiBaseUrl}/train/findTrainPage`, data,{
                  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.records
                  requestParameters.pageNum = res.data.data.current
                  requestParameters.pageSize = res.data.data.size
                  requestParameters.total = res.data.data.total

              }).catch(error => {
                  console.error(error)
            })
        }
        const clearBtns = () =>{
            student.value = ""
            student_s.value = ""
            coursecancellationStatusInput.value = ""
            dateTimeList.value = []

            axios.post(`${apiBaseUrl}/train/findTrainPage`, requestParameters,{
                  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.records
                  requestParameters.pageNum = res.data.data.current
                  requestParameters.pageSize = res.data.data.size
                  requestParameters.total = res.data.data.total

              }).catch(error => {
                  console.error(error)
            })

        }
        const addBtns = () =>{
            titleAddShowDlong.value = '添加培训任务'
            AddShowDlong.value = true
        }

        const handleSizeChange = (size) =>{
            requestParameters.pageSize = size
            axios.post(`${apiBaseUrl}/train/findTrainPage`, requestParameters,{
                  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.records
                  requestParameters.pageNum = res.data.data.current
                  requestParameters.pageSize = res.data.data.size
                  requestParameters.total = res.data.data.total

              }).catch(error => {
                  console.error(error)
            })


        }
        const handleCurrentChange = (page) =>{
            requestParameters.pageNum = page
            axios.post(`${apiBaseUrl}/train/findTrainPage`, requestParameters,{
                  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  dataList.value = res.data.data.records
                  requestParameters.pageNum = res.data.data.current
                  requestParameters.pageSize = res.data.data.size
                  requestParameters.total = res.data.data.total

              }).catch(error => {
                  console.error(error)
            })

        }

        const handleClickView = (boom, edible)=>{
            // let { courseDate, courseEndTime, courseStartTime, subjectName } = edible
            // form.student = courseStartTime
            // form.student_s = courseEndTime
            // form.coursecancellationStatusInput = subjectName
            // form.dateTimeList = courseDate
            // ShowDlong.value = true
            if(boom === '编辑'){
                // ShowDlongDisabled.value = false
                titleAddShowDlong.value = '编辑培训任务'
                AddShowDlong.value = true
                // titleAddShowDlong.value = '编辑培训任务'
                // ShowDlongTitle.value = '编辑'
                edibleTrainId.value = edible.trainId
                handleDetails(edible.trainId)
            }
            if(boom === '详情'){
                // ShowDlongDisabled.value = true
                titleAddShowDlong.value = '培训任务详情'
                AddShowDlong.value = true
                // ShowDlongTitle.value = '培训任务详情'
                handleDetails(edible.trainId)
            }
        }

        const handleDetails =  (trainId) =>{
            axios.get(`${apiBaseUrl}/train/findTrainInfo/${trainId}`,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                let { tranTeacherId, tranContent, trainName, trainTaskDTOS, teacherNames } = res.data.data


                console.log(res.data.data, 'res.data.data')


                if(tranTeacherId){
                    Addform.TrainerName = tranTeacherId.split(',').map(Number)
                }

                if(trainName){
                    Addform.TrainName = trainName
                }

                let trainNumberDaysCopy = []
                let traindataCardListCopy = []

                trainTaskDTOS.map((itme)=>{
                    if(itme.numberDays){
                        let day = itme.numberDays === 1 ? '第一天' :  itme.numberDays === 2 ? '第二天' : itme.numberDays === 3 ? '第三天' : itme.numberDays === 4 ? '第四天' : itme.numberDays === 5 ? '第五天' : itme.numberDays === 6 ? '第六天' : itme.numberDays === 7 ? '第七天' : itme.numberDays === 8 ? '第八天' : itme.numberDays === 9 ? '第九天' : itme.numberDays === 10 ? '第十天' : itme.numberDays === 11 ? '第十一天' : itme.numberDays === 12 ? '第十二天' : itme.numberDays === 13 ? '第十三天' :  '第十四天'
                        trainNumberDaysCopy.push(day)
                    }

                    if(itme.trainTaskInfoDTO){
                        itme.trainTaskInfoDTO.forEach((itmes)=>{
                            if(itmes.auditId){
                                itmes.auditId = Number(itmes.auditId)
                            }
                            if(itmes.taskData){
                                itmes.taskDataS = JSON.parse(itmes.taskData)
                            }else{
                                itmes.taskDataS = []
                            }
                        })

                        traindataCardListCopy.push(itme.trainTaskInfoDTO)
                    }

                })

                newObj.dateList = trainNumberDaysCopy
                newObj.dataCardList = traindataCardListCopy

              }).catch(error => {
                  console.error(error)
            })
        }

        const trimFromLastSlash = (str) =>{
            let lastSlashIndex = str.lastIndexOf('/')
            return str.slice(lastSlashIndex + 1)
        }

        const commitCler = () =>{
            ShowDlong.value = false
            handleClrAll()
        }

        const commitAdd = () =>{
            ShowDlong.value = false
            handleClrAll()
        }

        const handleClrAll = () =>{
            form.student = ""
            form.student_s = ""
            form.coursecancellationStatusInput = ""
            form.dateTimeList = ""
        }

        const AddcommitCler = () =>{
            handleClerAllDing()
        }

        const handleUrlMap = () =>{
           let MapList = fileDataList.value.map((itme)=>{
                let Url = []
                if(itme.url){
                    Url.push(itme.url)
                }
                return Url
            })

            Addform.DataUpload = MapList.join(',')
        }

        const AddcommitAdd = () =>{
            handleUrlMap()
            console.log(Addform, 'Addform')
            console.log(fileDataList.value, 'fileDataList')
            console.log(newObj, 'newObj')

            setTimeout(()=>{
              console.log('延迟答应---------控制台展示最后效果')
              handleClerAllDing()
           },3000)
        }

        const AddcommitSub = () =>{

            if(titleAddShowDlong.value === '编辑培训任务'){
                datahowDlong_2.value = true
            }else{
                if(!Addform.TrainName){
                    handleMessage("请输入方案名称或选择参加培训人", 'warning')
                }else{
                    handleUrlMap()

                    let trainTaskDTOS = []

                    if(newObj.dateList && newObj.dateList.length > 0){
                        newObj.dateList.map((itme,index)=>{
                            let numberDays =  index + 1
                            trainTaskDTOS.push({ numberDays,trainTaskInfoDTO:[] })
                        })
                    }




                    if(newObj.dataCardList && newObj.dataCardList.length > 0){
                        newObj.dataCardList.map((itme,index)=>{

                            trainTaskDTOS[index].trainTaskInfoDTO = itme

                            itme.map((itmes,indexs)=>{

                                trainTaskDTOS[index].trainTaskInfoDTO[indexs].taskNum =  indexs + 1
                                trainTaskDTOS[index].trainTaskInfoDTO[indexs].taskNumber =  indexs + 1 + getRandomLetterA() + getRandomLetterB() + getRandomLetterC() + getRandomLetterD() + getRandomLetterE() + getRandomLetterF() + getRandomLetterG() +  getRandomLetterH()
                            })

                        })
                    }



                    if(trainTaskDTOS && trainTaskDTOS.length > 0){
                        trainTaskDTOS.map((itme)=>{
                            itme.trainTaskInfoDTO.map((itmes,index)=>{
                                let list = []
                                if(itmes.taskDataS){
                                    itmes.taskDataS.map((itmess,indexx)=>{
                                        let obj = {}
                                        obj.url = itmess.url
                                        obj.name = itmess.name
                                        list.push(obj)
                                        itmes.taskData_s = list
                                    })
                                }
                            })
                        })



                        trainTaskDTOS.map((itme)=>{
                            itme.trainTaskInfoDTO.map((itmes,index)=>{
                                if(itmes.taskData_s){
                                    // itmes.taskData = itmes.taskData_s.join(',')
                                    itmes.taskData = JSON.stringify(itmes.taskData_s)
                                }
                            })
                        })
                    }



                    let arrayOfObjects = []

                    if(trainTaskDTOS && trainTaskDTOS.length > 0){
                            arrayOfObjects = trainTaskDTOS.map((itme) => {
                            itme.trainTaskInfoDTO.map((itmes)=>{
                                if(itmes.taskDataS){
                                    delete itmes.taskDataS
                                }
                                if(itmes.taskData_s){
                                    delete itmes.taskData_s
                                }
                                return itmes
                            })
                            return itme
                        })
                    }


                    let data = {
                        trainName: Addform.TrainName,
                        tranTeacherId: Addform.TrainerName.join(','),
                        tranContent: JSON.stringify(arrayOfObjects),
                    }

                    if(Addform.TrainName && Addform.TrainerName){
                        axios.post(`${apiBaseUrl}/train/addTrain`, data,{
                            headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
                        }).then(res => {
                            if(res.data.code === 200){
                                handleMessage("添加成功", 'success')
                                handleClerAllDing()
                            }else{
                                handleMessage("添加失败", 'error')
                            }
                        }).catch(error => {
                            console.error(error)
                        })
                    }
                }
            }

        }

        const handleClerAllDing = () =>{
            newObj.dateList = ['第一天']
            newObj.dataCardList = [[{taskDataS:[]}]]
            Addform.TrainName = ''
            Addform.TrainerName = []
            fileDataList.value = []
            activeStep.value = 0
            AddShowDlong.value = false

            axios.post(`${apiBaseUrl}/train/findTrainPage`, requestParameters,{
                  headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },
              }).then(res => {
                  isReturn(res.code)
                  if(res.data.code == 200){
                     handleMessage("查询成功", 'success')
                  }
                  dataList.value = res.data.data.records
                  requestParameters.pageNum = res.data.data.current
                  requestParameters.pageSize = res.data.data.size
                  requestParameters.total = res.data.data.total

              }).catch(error => {
                  console.error(error)
            })

        }

        const clickitem = (itme) =>{
            console.log(itme, 'itme')
        }

        const handleRemove = (file, fileList) =>{
            fileDataList.value = fileList
        }

        const handleRemove_s = (file, fileList) =>{
            fileDataList_s.value = fileList
        }

        const getFileName = (name) => {
             return name.substring(name.lastIndexOf("."))
        }

        const beforeUpload = (file, fileList) =>{
            loadingUtils.startLoading()
            const fileExtensions =
                getFileName(file.name) === ".bmp" ||
                getFileName(file.name) === ".tif" ||
                getFileName(file.name) === ".gif" ||
                getFileName(file.name) === ".pcx" ||
                getFileName(file.name) === ".svg" ||
                getFileName(file.name) === ".psd" ||
                getFileName(file.name) === ".webp" ||
                getFileName(file.name) === ".apng" ||
                getFileName(file.name) === ".ai" ||
                getFileName(file.name) === ".avif" ||
                getFileName(file.name) === ".png" ||
                getFileName(file.name) === ".pdf"||
                getFileName(file.name) === ".mp4"||
                getFileName(file.name) === ".excel"||
                getFileName(file.name) === ".doc"||
                getFileName(file.name) === ".ppt"||
                getFileName(file.name) === ".mp3"||
                getFileName(file.name) === ".xls"||
                getFileName(file.name) === ".xlsx"||
                getFileName(file.name) === ".pptx"||
                getFileName(file.name) === ".docx"||
                getFileName(file.name) === ".txt"||
                getFileName(file.name) === ".jpg";
            const max20M = file.size / 1024 / 1024 < 1000;

            if (!fileExtensions) {
                handleMessage("上传文件类不合格式!", 'warning')
            }
            if (!max20M) {
                handleMessage("上传文件类不合格式!", 'warning')
            }

            return fileExtensions && max20M
        }

        const beforeUpload_s = (file, fileList) =>{
            loadingUtils.startLoading()
            const fileExtensions =
                getFileName(file.name) === ".bmp" ||
                getFileName(file.name) === ".tif" ||
                getFileName(file.name) === ".gif" ||
                getFileName(file.name) === ".pcx" ||
                getFileName(file.name) === ".svg" ||
                getFileName(file.name) === ".psd" ||
                getFileName(file.name) === ".webp" ||
                getFileName(file.name) === ".apng" ||
                getFileName(file.name) === ".ai" ||
                getFileName(file.name) === ".avif" ||
                getFileName(file.name) === ".png" ||
                getFileName(file.name) === ".pdf"||
                getFileName(file.name) === ".mp4"||
                getFileName(file.name) === ".excel"||
                getFileName(file.name) === ".doc"||
                getFileName(file.name) === ".ppt"||
                getFileName(file.name) === ".mp3"||
                getFileName(file.name) === ".xls"||
                getFileName(file.name) === ".xlsx"||
                getFileName(file.name) === ".pptx"||
                getFileName(file.name) === ".docx"||
                getFileName(file.name) === ".txt"||
                getFileName(file.name) === ".jpg";
            const max20M = file.size / 1024 / 1024 < 1000;

            if (!fileExtensions) {
                handleMessage("上传文件类不合格式!", 'warning')
            }
            if (!max20M) {
                handleMessage("上传文件类不合格式!", 'warning')
            }

            return fileExtensions && max20M
        }

        const handleUpload = (option) =>{
            let obj = option.file.name
            let index = obj.lastIndexOf(".")
            obj = obj.substring(index, obj.length)
            let objName = getFileNameUUID() + getFileName(option.file.name)
            put(`mz_pc/${objName}`, option.file).then((res) => {
                loadingUtils.endLoading()

                fileDataList.value.push(res)
                signatureUrl(`mz_pc/${objName}`).then((res) => {})
            });
        }

        const handleUpload_s = (option) =>{
            let obj = option.file.name
            let index = obj.lastIndexOf(".")
            obj = obj.substring(index, obj.length)
            // let objName = getFileNameUUID() + getFileName(option.file.name)
            let objName = option.file.name
            put(`mz_pc/${objName}`, option.file).then((res) => {
                loadingUtils.endLoading()

                let replacedStr = res.name.replace("mz_pc/", "")
                res.name =  replacedStr

                fileDataList_s.value.push(res)

                signatureUrl(`mz_pc/${objName}`).then((res) => {})
            });
        }

        const handleError = () =>{
            loadingUtils.endLoading()
        }

        const handleError_s = () =>{
            loadingUtils.endLoading()
        }


        const handleRemoveTag = (e) => {
            if(titleAddShowDlong.value !== '添加培训任务'){
                newID.value = e
                Addform.TrainerName.push(e)
                refs.select.blur()
                datahowDlong_1.value =  true
            }
        }


        let teacherIdList = ref([])

        const datahowDlong_1Cler = () => {
            let list = []
            list.push({ teacherId: newID.value, isDelete: 1 })


            Addform.TrainerName = Addform.TrainerName.filter((item,index)=>{
                return item !== newID.value
            })

            teacherIdList.value = [...teacherIdList.value,...list]

            datahowDlong_1.value = false
        }

        const datahowDlong_1Sub = () => {
            newID.value = ''
            datahowDlong_1.value = false
        }


        const datahowDlong_2Cler = () => {

            let trainTaskDTOS = []

            if(newObj.dateList && newObj.dateList.length > 0){
                newObj.dateList.map((itme,index)=>{
                    let numberDays =  index + 1
                    trainTaskDTOS.push({ numberDays,trainTaskInfoDTO:[] })
                })
            }




           if(newObj.dataCardList && newObj.dataCardList.length > 0){
               newObj.dataCardList.map((itme,index)=>{

                    trainTaskDTOS[index].trainTaskInfoDTO = itme

                    itme.map((itmes,indexs)=>{

                        if(trainTaskDTOS[index].trainTaskInfoDTO[indexs].taskNumber){
                            console.log(trainTaskDTOS[index].trainTaskInfoDTO[indexs].taskNumber, 'trainTaskDTOS[index].trainTaskInfoDTO[indexs].taskNumber')
                            trainTaskDTOS[index].trainTaskInfoDTO[indexs].taskNum =  indexs + 1
                        }else{
                            trainTaskDTOS[index].trainTaskInfoDTO[indexs].taskNum =  indexs + 1
                            trainTaskDTOS[index].trainTaskInfoDTO[indexs].taskNumber =  indexs + 1 + getRandomLetterA() + getRandomLetterB() + getRandomLetterC() + getRandomLetterD() + getRandomLetterE() + getRandomLetterF() + getRandomLetterG() +  getRandomLetterH()
                        }

                     })

               })
            }



            if(trainTaskDTOS && trainTaskDTOS.length > 0){
               trainTaskDTOS.map((itme)=>{
                   itme.trainTaskInfoDTO.map((itmes,index)=>{
                      let list = []
                        if(itmes.taskDataS){
                            itmes.taskDataS.map((itmess,indexx)=>{
                                 let obj = {}
                                 obj.url = itmess.url
                                 obj.name = itmess.name
                                 list.push(obj)
                                itmes.taskData_s = list
                            })
                       }
                })
            })



            trainTaskDTOS.map((itme)=>{
                 itme.trainTaskInfoDTO.map((itmes,index)=>{
                      if(itmes.taskData_s){
                       // itmes.taskData = itmes.taskData_s.join(',')
                         itmes.taskData = JSON.stringify(itmes.taskData_s)
                        }
                    })
                })
            }



            let arrayOfObjects = []

             if(trainTaskDTOS && trainTaskDTOS.length > 0){
                   arrayOfObjects = trainTaskDTOS.map((itme) => {
                   itme.trainTaskInfoDTO.map((itmes)=>{
                        if(itmes.taskDataS){
                            delete itmes.taskDataS
                        }
                        if(itmes.taskData_s){
                            delete itmes.taskData_s
                        }
                     return itmes
                   })
                     return itme
                })
            }

            console.log(teacherIdList.value)
            console.log(trainDeleteTaskList.value)
            console.log(newObj, 'newObj')

            loadingUtils.startLoading()

            let data = {
                  trainName: Addform.TrainName,
                  tranTeacherId: Addform.TrainerName.join(','),
                  tranContent: JSON.stringify(arrayOfObjects),
                  trainTaskDeleteTeacherList: teacherIdList.value,
                  trainDeleteTaskList: trainDeleteTaskList.value,
                  trainUpdateStatus: datahowDlong_2Radio.value,
            }
            axios.post(`${apiBaseUrl}/train/modifyTrain/${edibleTrainId.value}`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                console.log(res, 'res')
                if(res.data.code === 200){
                    loadingUtils.endLoading()
                     handleMessage(res.data.message, 'success')
                     handleClerAllDing()
                     tranTeacherIdList.value = []
                     teacherIdList.value = []
                     datahowDlong_2Radio.value = ''
                     edibleTrainId.value = ''
                     trainDeleteTaskList.value = []
                     datahowDlong_2.value = false
                     AddShowDlong.value = false
                 }else{
                     handleMessage(res.message, 'error')
                     loadingUtils.endLoading()
                  }
              }).catch(error => {
                  console.error(error)
                  loadingUtils.endLoading()
            })

        }

        const datahowDlong_2Sub = () => {
            datahowDlong_2.value = false
        }


        const datahowDlong_3Cler = () => {

            datahowDlong_3.value = false
        }


        let trainDeleteTaskList = ref([])

        const datahowDlong_3Sub = () => {
            if( newindex.value !== 0){

                let list = { numberDays: activeStep.value + 1 , taskNumber: itmeRes.taskNumber, isDelete: 1  }
                trainDeleteTaskList.value.push(list)

                let result = deleteByIndex(newObj.dataCardList[activeStep.value], newindex.value)
                newObj.dataCardList[activeStep.value] = result
                datahowDlong_3.value = false
            }
        }



        const handleVideo = (url) =>{
          if(url.includes('.mp4')){
            videoSrc.value = url
            handleVideoShow.value = true
          }else{
            window.open(url, '_blank')
          }
        }


        let handleVideoShowCler = () =>{
          videoSrc.value = ''
          handleVideoShow.value = false
        }



        return {
            handleRemoveTag,
            trainDeleteTaskList,
            handleVideoShowCler,
            handleVideoShow,
            videoSrc,

            handleDetails,
            InputRadio,
            titleAddShowDlong,
            reviewerOptions,
            reviewerOptions_s,
            handleUpload_s,
            beforeUpload_s,
            handleError_s,
            handleRemove_s,
            handleUpload,
            beforeUpload,
            trimFromLastSlash,
            handleError,
            getFileName,
            handleRemove,
            handleClerAllDing,
            fileDataList,
            fileDataList_s,
            clickitem,
            handleVideo,
            newID,
            itmeRes,
            AddcommitCler,
            AddcommitAdd,
            commitCler,
            commitAdd,
            handleMessage,
            getStudentsArr,
            getStudentsArr_s,
            coursecancellationStatus,
            student,
            student_s,
            edibleTrainId,
            planArr,
            coursecancellationStatusInput,
            dateTimeList,
            handleAllApi,
            exportBtns,
            searchBtns,
            clearBtns,
            addBtns,
            dataList,
            handleClickView,
            handleSizeChange,
            handleCurrentChange,
            requestParameters,
            ShowDlongTitle,
            ShowDlong,
            tranTeacherIdList,
            form,
            mapList,
            handleStep,
            numberToChinese,
            ShowDlongDisabled,
            handleClrAll,
            AddcommitSub,
            AddShowDlong,
            Addform,
            // dateList,
            handleAdd,
            handleSubtraction,
            handleAddCard,
            // dataCardList,
            handdleClickImg,
            activeStep,
            datahowDlong,
            dataCommitCler,
            dataCommitSub,
            newObj,
            imgIndex,
            newindex,
            handleUrlMap,
            deleteByIndex,
            datahowDlong_1,
            datahowDlong_1Cler,
            datahowDlong_1Sub,
            datahowDlong_2Radio,
            datahowDlong_2,
            datahowDlong_2Cler,
            datahowDlong_2Sub,
            datahowDlong_3Radio,
            datahowDlong_3,
            datahowDlong_3Cler,
            datahowDlong_3Sub,
            select,
            teacherIdList,
        }

    }

})


</script>

<style scoped  lang="less">

/deep/ .el-upload-dragger{
    width: 100%;
}

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

/deep/ .el-upload{
    width: 100% !important;
    border: 1px solid #fff;
}


/deep/ .el-step__icon{
    display: none;
}

/deep/ .is-simple{
    margin-right: 20px;
}

/deep/ .el-step__main{
    width: 80px;
}

/deep/ .el-steps--simple{
    background: #fff;
}


/deep/ .is-process{
    color: #09a3e0 !important;
}

/deep/ .is-finish{
    color: #000 !important;
}

.no_click {
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// src/initAssembly/TrainingManagement.vue